// utils
import get from "../../../utils/GetNested";
import getPrettyIntegrationName from "../../../utils/getPrettyIntegrationName";

const selectSyncType = (log) => {
	if (log?.integration_type === "integration-sync") {
		return "integration";
	} else if (log?.integration_type === "csv" || log?.integration_type === "sftp-upload") {
		return "sftp";
	} else if (log?.integration_type === "csv-upload") {
		return "csv";
	} else if (log?.integration_type === "connect-workers") {
		return "connect-workers";
	}

	return null;
};

export const selectSyncInformation = (log) => {
	const type = selectSyncType(log);

	if (type === "integration") {
		const integrationName = get(log, ["integrationProperties", "integrationName"], "");
		return `${getPrettyIntegrationName(integrationName)} Integration`;
	} else if (type === "sftp") {
		const sftpName = get(log, ["sftp_properties", "sftp_integration_name", "name"], "");
		return `${sftpName} SFTP Sync`;
	} else if (type === "csv") {
		return "CSV Upload";
	} else if (type === "connect-workers") {
		let integrationName = get(log, ["integrationProperties", "integrationName"], "");
		if (integrationName.length > 0) {
			integrationName = integrationName[0].toUpperCase() + integrationName.slice(1);
		}

		return `${integrationName} Integration Settings Update`;
	}

	return "";
};
